export const ENABLE_MOCKS = new URLSearchParams(window.location.search).has(
  'mocks',
);

export const INTERCOM_APP_ID = 'lsm17xih';

export const SENTRY_DSN = `https://229f3aec4883901402c1b1cd5e597142@o4504039106871296.ingest.sentry.io/4506774896377856`;
